import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=c21a5076&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=c21a5076&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21a5076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c21a5076')) {
      api.createRecord('c21a5076', component.options)
    } else {
      api.reload('c21a5076', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=c21a5076&scoped=true", function () {
      api.rerender('c21a5076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aboutUS/components/Contact.vue"
export default component.exports